"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MobilePopover_1 = require("../components/MobilePopover");
class DeviceListSelectorModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.POPOVER_NAME = 'device-list-selector-modal';
        this.state = {
            isSearchFocused: false,
            searchString: '',
        };
        this.closePopover = this.closePopover.bind(this);
        this.setState = this.setState.bind(this);
    }
    closePopover() {
        const { device, closePopoverModalForm, updateActivePopover } = this.props;
        this.setState({
            isSearchFocused: false,
            searchString: '',
        });
        closePopoverModalForm();
        window.setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
    }
    renderPopoverSearch() {
        const { device } = this.props;
        const { isSearchFocused, searchString } = this.state;
        return (React.createElement(src_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({
                isSearchFocused: false,
            }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (searchString) => this.setState({ searchString }), text: searchString }));
    }
    renderDeviceLists() {
        const { device, deviceLists, updateSegmentDeviceList } = this.props;
        const { searchString } = this.state;
        return (React.createElement("div", { style: {
                width: device === 'Mobile' ? '100%' : 384,
                height: device === 'Mobile' ? '100%' : 296,
                display: 'flex',
                flexDirection: 'column',
            } },
            this.renderPopoverSearch(),
            React.createElement("div", { style: {
                    flex: '1 1 auto',
                    overflowY: 'scroll',
                    paddingBottom: device === 'Mobile' ? 55 : 0,
                } },
                React.createElement(src_1.SelectableList, { device: device }, deviceLists
                    .filter(({ name }) => name.toLowerCase().includes(searchString.toLowerCase()) || searchString === '')
                    .map(({ id, name, size, createdAt }) => (React.createElement("div", { key: id, onClick: () => {
                        updateSegmentDeviceList(id, name, size, createdAt);
                        this.closePopover();
                    }, style: {
                        height: 55,
                        paddingTop: 16,
                    } },
                    React.createElement(src_1.Text, { text: name, size: "large" }))))))));
    }
    render() {
        const { activePopover, children, device, isPopoverModalFormOpen } = this.props;
        if (device === 'Mobile') {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", null, children),
                activePopover === this.POPOVER_NAME &&
                    ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                            title: 'Automated Lists',
                            buttonLeft: 'Cancel',
                            buttonLeftCallback: this.closePopover,
                        } }, this.renderDeviceLists()), document.getElementById('mainModalLeft'))));
        }
        return (React.createElement(src_1.PopoverContainer, { id: this.POPOVER_NAME, onClick: () => activePopover === this.POPOVER_NAME
                ? actions_1.updateActivePopover('')
                : actions_1.updateActivePopover(this.POPOVER_NAME), popoverProps: {
                placement: 'left',
                device: device,
                navBarProperties: {
                    title: 'Automated Lists',
                    buttonLeft: 'Cancel',
                    buttonLeftCallback: this.closePopover,
                },
                overlayClickHandler: () => this.closePopover(),
            }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', showPopover: activePopover === this.POPOVER_NAME },
            children,
            this.renderDeviceLists()));
    }
}
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    deviceLists: reducers_1.getDeviceLists(state),
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
        updateActivePopover: (field) => dispatch(actions_1.updateActivePopover(field)),
        updateSegmentDeviceList: (id, name, size, createdAt) => dispatch(actions_1.updateSegmentDeviceList(id, name, size, createdAt)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DeviceListSelectorModal);
